import {
  BlockTypeEnum,
  PaperBlock,
  PaperQuestion,
  QuestionTypeEnum,
  SortBlock,
} from 'packages/sdks-next/growp'
import { AnyType } from 'packages/types'
import { createUuid } from '@seiue/react-flow-builder'
import { cloneDeep, find, pick } from '@seiue/util'

/**
 * 更新questions
 */
export const editQuestion = (
  questions: PaperQuestion[],
  id: number,
  newParam: { [key: string]: AnyType }
) => {
  const newQuestions = questions.map((question) => {
    if (question.id === id) {
      return {
        ...question,
        ...newParam,
      }
    } else {
      return question
    }
  })
  return newQuestions
}

/**
 * 引用题目格式化
 * 1.先过滤掉非题目的block,抽题模式下只保留选择题目
 * 2.去除引用过来的block中的各类id,并设置treeNodeId, treeNodePid
 * @param originBlocks - 引用过来的原始blocks
 * @param isRand - 是否是抽题模式
 */
export const quoteBlocksFormat = (
  originBlocks: PaperBlock[],
  paperId: number,
  isRand = false
) => {
  return originBlocks
    .filter((b) => {
      if (isRand) {
        const obj = find(b.questions, { parentId: 0 })
        if (
          b.type === BlockTypeEnum.Question &&
          obj?.type &&
          [
            QuestionTypeEnum.SingleChoice,
            QuestionTypeEnum.MultipleChoice,
          ].includes(obj?.type)
        ) {
          return true
        }
        return false
      }
      return true
    })
    .map((block) => {
      const newQuestions = block.questions?.map((question) => {
        const {
          type,
          stem,
          standardAnswers,
          analysis,
          settings,
          options,
          score,
          id,
          parentId,
          weight,
          isQuestion,
        } = question
        return {
          type,
          stem,
          standardAnswers,
          analysis,
          settings,
          options,
          score,
          treeNodeId: id,
          treeNodePid: parentId,
          weight,
          isQuestion,
        }
      })
      return {
        hash: createUuid(),
        paperId: paperId,
        type: block.type,
        content: block.content,
        weight: block.weight,
        questions: newQuestions,
        treeNodeId: block.id,
        treeNodePid: block.parentId,
      }
    })
}

/**
 * 插入引用的blocks并排序
 * @param blocks - 当前试卷的blocks
 * @param quoteBlocks - 引用试卷的blocks
 * @param insertIndex - 插入的位置索引
 * @returns 新的blocks
 */
export const insertQuoteBlocks = (
  blocks: PaperBlock[],
  quoteBlocks: PaperBlock[],
  insertIndex: number
) => {
  const copyBlocks = cloneDeep(blocks)
  copyBlocks?.splice(insertIndex, 0, ...quoteBlocks)
  const newBlocks: SortBlock[] =
    copyBlocks
      ?.map((b, index) => {
        return {
          ...b,
          weight: index,
        }
      })
      .map((b) => pick(b, ['weight', 'parentId', 'id'])) || []
  return newBlocks
}
